// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3wgzx","gfeWrapper":"CalendarEvent_gfeWrapper__2M6lK"};